import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Facebook, Instagram, Twitter } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#003366] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* EKIP Holding */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-[#FFB81C]">EKIP Holding</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors">
                  Nos valeurs
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors">
                  Gouvernance
                </Link>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-white transition-colors">
                  Carrières
                </a>
              </li>
            </ul>
          </div>

          {/* Nos Filiales */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-[#FFB81C]">Nos Filiales</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/subsidiaries" className="text-gray-300 hover:text-white transition-colors">
                  Kip Energy
                </Link>
              </li>
              <li>
                <Link to="/subsidiaries" className="text-gray-300 hover:text-white transition-colors">
                  KIDH
                </Link>
              </li>
              <li>
                <Link to="/subsidiaries" className="text-gray-300 hover:text-white transition-colors">
                  EKIPTECH
                </Link>
              </li>
              <li>
                <Link to="/subsidiaries" className="text-gray-300 hover:text-white transition-colors">
                  KIPAY
                </Link>
              </li>
            </ul>
          </div>

          {/* Nos Projets */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-[#FFB81C]">Nos Projets</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/projects" className="text-gray-300 hover:text-white transition-colors">
                  Infrastructure énergétique
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-gray-300 hover:text-white transition-colors">
                  Développement immobilier
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-gray-300 hover:text-white transition-colors">
                  Réseau Wayne
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-gray-300 hover:text-white transition-colors">
                  Actualités
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-[#FFB81C]">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={20} className="text-[#FF6600] flex-shrink-0 mt-1" />
                <span className="text-gray-300 text-sm">
                  Cocody 2 Plateaux Boulevard Latrille 49 Rue K104, Abidjan, Côte d'Ivoire
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={20} className="text-[#FF6600] flex-shrink-0" />
                <span className="text-gray-300 text-sm">+225 27 22 41 25 25</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={20} className="text-[#FF6600] flex-shrink-0" />
                <a href="mailto:contact@ekipholding.ci" className="text-gray-300 text-sm hover:text-white transition-colors">
                  contact@ekipholding.ci
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Media & Copyright */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-gray-400 text-sm">
            © 2024 EKIP Holding Company. Tous droits réservés.
          </div>
          
          <div className="flex items-center space-x-6">
            <a href="https://www.linkedin.com/company/ekip-holding-company/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#FF6600] transition-colors" aria-label="LinkedIn">
              <Linkedin size={20} />
            </a>
            <a href="https://www.facebook.com/EkipHolding/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#FF6600] transition-colors" aria-label="Facebook">
              <Facebook size={20} />
            </a>
            <a href="#" className="text-gray-400 hover:text-[#FF6600] transition-colors" aria-label="Instagram">
              <Instagram size={20} />
            </a>
            <a href="#" className="text-gray-400 hover:text-[#FF6600] transition-colors" aria-label="Twitter">
              <Twitter size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};